export default [
    {
        path: '/fillin', // 填写会员信息
        component: resolve => require(['@/pages/member/fillIn'], resolve),
        meta: { title: "长龙航空" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/member.js